import { useState } from "react";
import { HardHat } from "lucide-react";
import { Switch } from "@/components/ui/switch";

const apply = (on) => document.documentElement.classList.toggle("chantier", on);
apply(localStorage.getItem("btp_chantier") === "on");

export function ChantierModeSettings() {
  const [on, setOn] = useState(() => document.documentElement.classList.contains("chantier"));
  const toggle = (v) => {
    setOn(v);
    apply(v);
    localStorage.setItem("btp_chantier", v ? "on" : "off");
  };
  return (
    <div className="bg-white rounded-2xl border-2 border-slate-200 p-4 flex items-center gap-3 rise rise-1" data-testid="chantier-mode-settings">
      <span className="w-12 h-12 rounded-xl bg-orange-500 text-slate-900 grid place-items-center">
        <HardHat className="w-6 h-6" />
      </span>
      <div className="flex-1">
        <div className="font-display text-xl font-bold uppercase">Mode chantier</div>
        <div className="text-sm text-slate-600">Très gros, très contrasté, pour les gants</div>
      </div>
      <Switch checked={on} onCheckedChange={toggle} data-testid="chantier-mode-toggle" />
    </div>
  );
}
